<template>
  <div v-if="loaded"
       class="million-read-report-share"
  >
    <div class="million-read-report-share-header">
      <div class="million-read-report-share-header-bar">
        <header-back-btn />
      </div>
      <div class="million-read-report-share-header-user-info">
        <ym-img class="avatar"
                :src="userInfo.avatar"
        />
        <div class="detail">
          <div class="name">
            <span>{{ userInfo.name }}</span>
            <ym-img v-if="vip && vip.status === 'normal'"
                    class="vip-icon"
                    :src="require('@/assets/img/million_read/review_vip_icon.png')"
            />
          </div>
          <div class="joined-day">加入百万阅读{{ userInfo.joinedDay }}天</div>
        </div>
      </div>
    </div>
    <div class="million-read-report-share-my-week-info">
      <div class="million-read-report-share-my-week-info-header">
        <div class="title">我的一周</div>
        <div class="date">{{ report.date }}</div>
      </div>
      <report-week-data class="million-read-report-share-my-week-info-detail"
                        :this-week="thisWeek"
                        :last-week="lastWeek"
                        :exceed-percent="report.exceedPercent"
      />
    </div>

    <report-my-harvest class="million-read-report-share-my-harvest"
                       :harvest="harvest"
    />
    <report-learn-advice :advice="advice"
                         :is-owner="render.isOwner"
    />
    <div class="million-read-report-share-footer">
      <div class="million-read-report-share-footer-title">解读经典名著，让孩子轻松爱上阅读</div>
      <ym-img class="million-read-report-share-footer-icon"
              :src="require('@/assets/img/million_read/report_footer_icon.png')"
      />
      <div class="million-read-report-share-footer-action"
           @click="handleToPreSale"
      >
        我也要开始阅读
      </div>
    </div>
  </div>
</template>

<script>
  import { HeaderBackBtn } from '@ymba/ym-ui';
  import ReportWeekData from '@/pages/MillionRead/components/ReportWeekData';
  import ReportMyHarvest from '@/pages/MillionRead/components/ReportMyHarvest';
  import ReportLearnAdvice from '@/pages/MillionRead/components/ReportLearnAdvice';
  import { reportShare } from '@/services/million-read';

  export default {
    name: 'MillionReadReportShare',
    metaInfo: {},
    components: {
      HeaderBackBtn,
      ReportWeekData,
      ReportMyHarvest,
      ReportLearnAdvice,
    },
    props: {},
    data() {
      return {
        loaded: false,
        totalReport: null,
        report: null,
        harvest: null,
        advice: null,
        thisWeek: null,
        lastWeek: null,
        render: null,
        userInfo: null,
        vip: null,
      };
    },
    methods: {
      async fetchData() {
        const id = this.$route.query && this.$route.query.id ? this.$route.query.id : 0;
        const data = await reportShare(id);
        this.totalReport = data.totalReport;
        this.report = data.report;
        this.harvest = data.harvest;
        this.advice = data.advice;
        this.thisWeek = data.thisWeek;
        this.lastWeek = data.lastWeek;
        this.render = data.render;
        this.userInfo = data.userInfo;
        this.vip = data.vip;
        this.loaded = true;
      },
      handleToPreSale() {
        this.$router.push({
          name: 'MillionReadVipPreSaleDetail',
          params: { id: 1 },
        });
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-report-share {
    background: @color-white;
    &-header {
      box-sizing: border-box;
      position: relative;
      z-index: 1;
      width: 100%;
      height: 446px;
      padding-top: 258px;
      background: url('~@/assets/img/million_read/report_share_header.png') no-repeat;
      background-size: cover;
      &-bar {
        box-sizing: border-box;
        position: absolute;
        top: 0;
        width: 100%;
        height: 88px;
        padding-left: @size-base;
      }
      &-user-info {
        box-sizing: border-box;
        padding-left: @size-medium;
        display: flex;
        align-items: center;
        .avatar {
          flex-shrink: 0;
          overflow: hidden;
          margin-right: 16px;
          width: 90px;
          height: 90px;
          border-radius: 50%;
        }
        .name {
          margin-bottom: 16px;
          display: flex;
          align-items: flex-end;
          color: @color-text-base;
          font-size: @font-size-large;
          font-weight: @font-weight-strong;
          line-height: 1;
          .vip-icon {
            width: 30px;
            height: 30px;
            margin-left: 8px;
          }
        }
        .joined-day{
          color: @color-text-base;
          font-size: 26px;
          line-height: 1;
        }
      }
    }
    &-my-week-info {
      box-sizing: border-box;
      position: relative;
      z-index: 2;
      width: 100%;
      margin: -@size-medium auto 0;
      padding: 80px @size-base 0 @size-base;
      background: @color-white;
      border-radius: 20px 20px 0 0;
      &-header {
        box-sizing: border-box;
        padding-left: @size-extra-small;
        display: flex;
        align-items: flex-end;
        .title {
          margin-right: 16px;
          color: @color-text-base;
          font-size: @font-size-extra-extra-large;
          font-weight: @font-weight-strong;
          line-height: 1;
        }
        .date {
          box-sizing: border-box;
          padding: 4px 16px;
          color: @color-text-lighter;
          font-size: 26px;
          line-height: 1;
          background: #f5f6f7;
          border-radius: 8px;
        }
      }
      &-detail {
        margin: -@size-small -@size-base 0 -@size-base;
      }
    }
    &-footer {
      box-sizing: border-box;
      padding-bottom: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: @color-white;
      &-title {
        margin-bottom: @size-medium;
        color: @color-text-base;
        font-size: @font-size-medium;
        font-weight: @font-weight-strong;
        line-height: 1;
      }
      &-icon {
        width: 152px;
        height: 152px;
        margin-bottom: 72px;
      }
      &-action {
        width: 424px;
        height: 88px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-base;
        font-size: @font-size-medium;
        font-weight: @font-weight-strong;
        background: #fed100;
        border-radius: 44px;
      }
    }
  }

</style>
